import * as React from 'react'

interface Ret00cGroupFilterCtx {
  selectedGroupId?: number
  setSelectedGroupId: (id?: number) => void
  openGroupModal: () => void
  reloadTree: () => void
}

const Ret00cGroupFilterContext = React.createContext<Ret00cGroupFilterCtx>({
  selectedGroupId: undefined,
  setSelectedGroupId: () => undefined,
  openGroupModal: () => undefined,
  reloadTree: () => undefined,
})

interface ProviderProps {
  children: React.ReactNode
  onOpenGroupModal?: () => void
  onReloadTree?: () => void
}

export function Ret00cGroupFilterProvider({ children, onOpenGroupModal, onReloadTree }: ProviderProps): JSX.Element {
  const [selectedGroupId, setSelectedGroupId] = React.useState<number | undefined>(undefined)

  const openGroupModal = React.useCallback(() => {
    onOpenGroupModal?.()
  }, [onOpenGroupModal])

  const reloadTree = React.useCallback(() => {
    onReloadTree?.()
  }, [onReloadTree])

  const value = React.useMemo<Ret00cGroupFilterCtx>(
    () => ({ selectedGroupId, setSelectedGroupId, openGroupModal, reloadTree }),
    [selectedGroupId, openGroupModal, reloadTree],
  )

  return (
    <Ret00cGroupFilterContext.Provider value={value}>
      {children}
    </Ret00cGroupFilterContext.Provider>
  )
}

export function useRet00cGroupFilter(): Ret00cGroupFilterCtx {
  return React.useContext(Ret00cGroupFilterContext)
}
